import PropTypes from 'prop-types';
import { ExclamationCircleFill } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { Message } from './Message';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UserWarningMessage(_ref) {
  var warnings = _ref.warnings,
      onClose = _ref.onClose;
  return /*#__PURE__*/_jsxs(Message, {
    variant: "warning",
    icon: ExclamationCircleFill,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      id: "result.warning.title"
    }), /*#__PURE__*/_jsx("ul", {
      className: "mb-0",
      children: warnings.map(function (warning, i) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "result.warning.item.".concat(warning)
          })
        }, i);
      })
    })]
  });
}
UserWarningMessage.propTypes = {
  warnings: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};